import { CircleHelp } from "lucide-react";
import { t } from "i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface Props {
  onClick: () => void;
}

export const UploadAudioButton = (props: Props): JSX.Element => {
  return (
    <div className="flex items-center gap-2">
      <button
        className="text-tinted-grey-3 text-base font-semibold cursor-pointer hover:text-primary underline hover:underline-offset-2 transition duration-300"
        onClick={props.onClick}
      >
        {t("visits.sidebar.uploadFile")}
      </button>
      <Tooltip>
        <TooltipTrigger asChild>
          <CircleHelp className="w-5 h-5 text-tinted-grey-3 cursor-pointer" />
        </TooltipTrigger>
        <TooltipContent className="max-w-xs whitespace-normal">
          <p>{t("error.formRecorder.supportedFormat")}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
